export var SplitButtonStylePropertiesByVariant = {
    default: function (theme) { return ({
        dividerColor: theme.contentOnColor,
    }); },
    outlined: function (theme) { return ({
        dividerColor: theme.contentPrimary,
        disabledDividerColor: theme.disabledPrimary,
        borderColor: theme.borderTertiary,
        disabledBorderColor: theme.disabledPrimary,
    }); },
    ghost: function (theme) { return ({
        dividerColor: theme.contentPrimary,
        disabledDividerColor: theme.disabledPrimary,
    }); },
};
//# sourceMappingURL=SplitButtonStylePropertiesByVariant.js.map